import { pyrotchBaseUrl, axiosBaseQuery } from "../axios/AxiosInstance";
import { createApi } from "@reduxjs/toolkit/query/react";
import { GoalRequest } from "../../models/Goals";
import { GoalResponse } from "../../models/Goals";
import { ProjectsResponse } from "../../models/Goals";

export const GoalApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "GoalApi",
  tagTypes: ["Goal"],

  endpoints(build) {
    return {
      createGoal: build.mutation<any, GoalRequest>({
        query: (GoalData) => ({
          url: `goal`,
          method: "POST",
          data: GoalData,
        }),
        invalidatesTags: ["Goal"],
      }),
      updateGoal: build.mutation<any, {GoalData: GoalRequest;goalId:number}>({
        query: ({GoalData, goalId}) => ({
          url: `goal/${goalId}`,
          method: "PUT",
          data: GoalData,
        }),
        invalidatesTags: ["Goal"],
      }),
      getGoals: build.query<GoalResponse, { page: number; size: number, search: string, goalType: string, userId: number, productTypeId: number }>({
        query: ({ page, size, search, goalType, userId, productTypeId }) => ({
          url: `goal?page=${page}&size=${size}`,
          method: "GET",
          params: {search, goalType, userId, productTypeId}
        }),
        providesTags: ["Goal"],
      }),
      deleteGoals: build.mutation<void, number>({
        query: (goalId) => {
          return {
            url: `goal/${goalId}`,
            method: "DELETE",
          };
        },
        invalidatesTags: ["Goal"],
      }),
      getprojectData:build.query<ProjectsResponse, { page: number; size: number; startDate: string; endDate: string }>({
        query: ({ page, size, startDate, endDate }) => ({
          url: `goal/name-and-key?page=${page}&size=${size}&startDate=${startDate}&endDate=${endDate}`,
          method: "GET",
        }),
      }),
      getAllGoalsOptions: build.query<any, any>({
        query: () => {
          return {
            url: `goal/all-goals`,
            method: "GET",
          };
        },
      }),
      getGoalCount: build.query<any, {userId: number}>({
        query: ({userId}) => ({
          url: `goal/count?userId=${userId}`,
          method: "GET"
        })
      }),
    };
  },
});

export const {
  useCreateGoalMutation,
  useLazyGetGoalsQuery,
  useDeleteGoalsMutation,
  useUpdateGoalMutation,
  useLazyGetprojectDataQuery,
  useGetprojectDataQuery,
  useLazyGetAllGoalsOptionsQuery,
  useLazyGetGoalCountQuery
} = GoalApi;
